import type { TOC } from '@ember/component/template-only';
import { pluralize } from 'ember-inflector';
import svgJar from 'ember-svg-jar/helpers/svg-jar';

interface ErrorCountSignature {
  Args: {
    count: number;
  };
}

export default <template>
  <p
    class="bg-papaya-10 text-papaya-60 text-sm leading-normal rounded-full my-0 mr-6 pt-1 pb-0.5 px-3 flex items-center"
    data-test-spreadsheet-error-summary
  >
    <div class="mt-px mr-1.5">
      {{svgJar "ui-caution" width="12" height="12"}}
    </div>
    <div class="uppercase font-bold">
      {{pluralize @count "error"}}
    </div>
  </p>
</template> satisfies TOC<ErrorCountSignature>;
